import { createSlice } from "@reduxjs/toolkit";
import { confirmLogin, otpAuthentication } from "./LoginThunks";

const initialState = {
  user: null,
  token: null,
  member: null,
  loading: false,
  error: null,
};

const loginItems = createSlice({
  name: "login",
  initialState,
  reducers: {
    logout(state) {
      state.user = null;
      state.token = null;
      state.member = null;
      localStorage.clear();
    }
  },
  extraReducers: builder => {
    builder
      .addCase(confirmLogin.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(confirmLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.error = action.payload.message !== "2FA code sent in the email successfully!" ? action.payload.message : null;
        if(action.payload.user && action.payload.user.account_type == "admin") {
          localStorage.setItem("user", JSON.stringify(action.payload.user))
        }
        else {
          state.error = "User not found!"
        }
      })
      .addCase(confirmLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(otpAuthentication.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(otpAuthentication.fulfilled, (state, action) => {
        state.loading = false;
        state.error = action.payload.message == "Invalid or expired 2FA code." ? action.payload.message : null;
        state.user = action.payload.user || null;
        state.token = action.payload.token || null;
        if (state.token) {
          localStorage.setItem("token", state.token);
        }
        if (state.user) {
          localStorage.setItem("user", JSON.stringify(state.user)); // <-- Store user info
        }
      })
      .addCase(otpAuthentication.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export const { logout } = loginItems.actions;
export default loginItems.reducer;